import { createContext, PropsWithChildren, useContext } from "react";
import { Employee } from "../types";

type DisableTravelerPickerContext = {
  employees: Employee[];
  nonEmployeeAdults: number;
  nonEmployeeChildren?: number;
};

const DisableTravelerPickerContext =
  createContext<DisableTravelerPickerContext>({
    employees: [],
    nonEmployeeAdults: 0,
    nonEmployeeChildren: 0,
  });

export default function DisableTravelerPickerProvider({
  children,
  ...props
}: PropsWithChildren<DisableTravelerPickerContext>) {
  return (
    <DisableTravelerPickerContext.Provider value={props}>
      {children}
    </DisableTravelerPickerContext.Provider>
  );
}

export function useDisableTravelerPicker() {
  const context = useContext(DisableTravelerPickerContext);

  if (context === undefined) {
    throw new Error(
      "`DisableTravelerPickerContext` could not find any provider"
    );
  }

  return context;
}
